<div class="app-content">
  <router-outlet></router-outlet>
  <lib-alert></lib-alert>
</div>

